var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 288,
    viewBox: "0 0 161 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_22224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.613 226.862V183.217H153.881V226.862H156.613Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.01 226.862V183.217H136.277V226.862H139.01Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.812 288.005V244.36H145.079V288.005H147.812Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8633 69.8076V17.4775H79.1307V69.8076H81.8633Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8633 139.636V87.3057H79.1307V139.636H81.8633Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8633 209.385V157.055H79.1307V209.385H81.8633Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8633 279.128V226.798H79.1307V279.128H81.8633Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.637 165.761V122.17H133.26V165.761H159.637Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.812 104.746V61.1006H145.079V104.746H147.812Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 104.746V61.1006H158.267V104.746H161Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.623 104.746V61.1006H131.89V104.746H134.623Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.812 43.645V0L145.079 0V43.645H147.812Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 43.645V0L158.267 0V43.645H161Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.623 43.645V0L131.89 0V43.645H134.623Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.246 43.645V0L105.514 0V43.645H108.246Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.435 43.645V0L118.702 0V43.645H121.435Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12012 226.862L7.12012 183.217H4.38759L4.38759 226.862H7.12012Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7227 226.862V183.217H21.9901V226.862H24.7227Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9209 288.005L15.9209 244.36H13.1883L13.1883 288.005H15.9209Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7402 165.761V122.17H1.36323V165.761H27.7402Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9209 104.746L15.9209 61.1006H13.1883L13.1883 104.746H15.9209Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73242 104.746L2.73242 61.1006H-0.00012207L-0.00012207 104.746H2.73242Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1094 104.746V61.1006H26.3768V104.746H29.1094Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9209 43.645L15.9209 0L13.1883 0L13.1883 43.645H15.9209Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73242 43.645L2.73242 0L-0.00012207 0L-0.00012207 43.645H2.73242Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1094 43.645V0L26.3768 0V43.645H29.1094Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4863 43.645V0L52.7538 0V43.645H55.4863Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2979 43.645V0L39.5653 0V43.645H42.2979Z",
    fill: "#BBBBBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_22224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 161,
    fill: "white",
    transform: "translate(161) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/asset1.5e8df335a89a95383bc77e5ae61ce1e1.svg";
export { ForwardRef as ReactComponent };